import React, { useState } from 'react';

import { getConfigObject } from '../../../../../utils/config';
import { ISG_REPORT_VIEW_OPTIONS } from '../../../../../utils/constants';
import MLIcon from '../../../../MLIcon';
import MLMenu from '../../../../MLMenu/MLMenu';
import { SearchBar } from '../SearchBar/SearchBar';
import s from './BodyHeader.module.css';

const INITIAL_MENU_STATE = { anchorEl: null, open: false };

export const BodyHeader = ({
  currentView,
  onViewOptionClick,
  // Header Search
  throttledSearchChange,
  searchTerm,
  resetSearch,
  handleSearchFocus,
}) => {
  const [menu, setMenu] = useState(INITIAL_MENU_STATE);
  const handleMenuOpen = (event) => {
    setMenu({ anchorEl: event.currentTarget, open: true });
  };

  const handleMenuClose = () => {
    setMenu(INITIAL_MENU_STATE);
  };

  const viewOptions = [
    {
      label: 'Gradebook Category',
      selected: currentView === ISG_REPORT_VIEW_OPTIONS.CATEGORY,
      onClick: () => {
        handleMenuClose();
        onViewOptionClick(ISG_REPORT_VIEW_OPTIONS.CATEGORY);
      },
      testId: 'ISG_view_by_gb_category',
    },
    {
      label: 'Week',
      selected: currentView === ISG_REPORT_VIEW_OPTIONS.WEEK,
      onClick: () => {
        handleMenuClose();
        onViewOptionClick(ISG_REPORT_VIEW_OPTIONS.WEEK);
      },
      testId: 'ISG_view_by_week',
    },
  ];

  if (getConfigObject().FF_ISR_SLICE_2) {
    viewOptions.push({
      label: 'Unit',
      selected: currentView === ISG_REPORT_VIEW_OPTIONS.UNIT,
      onClick: () => {
        handleMenuClose();
        onViewOptionClick(ISG_REPORT_VIEW_OPTIONS.UNIT);
      },
      testId: 'ISG_view_by_unit',
    });
  }

  return (
    <div className={s.bodyHeader}>
      <div className={s.searchBar}>
        <SearchBar
          searchTerm={searchTerm}
          placeholder="Search Assignments"
          onChange={throttledSearchChange}
          onReset={resetSearch}
          onFocus={handleSearchFocus}
        />
      </div>
      <div className={s.viewDropdown}>
        <span className={s.dropdownLabel}>View By:</span>
        <MLMenu
          open={menu.open}
          anchorEl={menu.anchorEl}
          alignment={'right'}
          options={viewOptions}
          handleOpen={handleMenuOpen}
          handleClose={handleMenuClose}
          ariaLabel={'Individual Student Report View Options'}
          menuItemClass={s.menuItem}
          optionLabelClass={s.viewByOptionLabel}
          selectedIconClass={s.viewBySelectedIcon}
          buttonLabel={currentView}
          buttonTestId="gradebook-category-dropdown-button"
          buttonClass={s.menuButton}
          buttonLabelClass={s.menuButtonLabel}
          buttonRightIcon={
            <MLIcon className={s.buttonRightIcon} type="caret_down" />
          }
        />
      </div>
    </div>
  );
};
